import angular from 'angular';
import Default from './default/default';
import Home from './home/home';
import Simulated from './simulated/simulated'

let pagesModule = angular.module('app.pages', [
  Default,
  Home,
  Simulated
])

.name;

export default pagesModule;



// WEBPACK FOOTER //
// ./client/app/pages/pages.js